gsap.registerPlugin(ScrollTrigger, SplitText,ScrollToPlugin);

const lenis = new Lenis({
  autoRaf: false,
  lerp : 0.1,
  smoothTouch : true
});

lenis.on('scroll', ScrollTrigger.update);



gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

window.lenis = lenis;


window.animationState = {
  canStart: false,
  listeners: [],
};

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

window.setCanStartAnimations = function (value) {
  animationState.canStart = value;

  if (value) {
    animationState.listeners.forEach((fn) => fn());
    animationState.listeners = [];
  }
};

window.initInView = function (
  selector = '[data-animation]',
  options = {}
) {
  const {
    className = 'in-view',
    delay = 0,
    offset = '0px',
    root = document,
  } = options;

  const els = Array.from(root.querySelectorAll(selector));

  if (!els.length) return;

  // Respect reduced motion
  if (prefersReducedMotion) {
    els.forEach((el) => el.classList.add(className));
    return;
  }

  const groups = new Map();

  els.forEach((el) => {
    const elOffset = el.dataset.offset || offset;

    if (!groups.has(elOffset)) {
      groups.set(elOffset, []);
    }

    groups.get(elOffset).push(el);
  });

  function start() {
    groups.forEach((groupEls, rootMargin) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const elDelay = entry.target.dataset.delay;
            const computedDelay =
              elDelay !== undefined ? Number(elDelay) : delay;

            setTimeout(() => {
              entry.target.classList.add(className);
            }, computedDelay);

            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin,
        }
      );

      groupEls.forEach((el) => observer.observe(el));
    });
  }

  if (animationState.canStart) {
    start();
  } else {
    animationState.listeners.push(start);
  }
};


document.addEventListener('DOMContentLoaded', () => {
  initInView();
  setCanStartAnimations(true);
  animations();
});
function animations(){
    const bodyTextElements = document.querySelectorAll('[data-animate="body"]');
    const parallaxElements = document.querySelectorAll('[data-animate="parallax"]');

    bodyTextElements.forEach((elem) => {
      if(!elem) return;
      let split = SplitText.create(elem, {
        type: "words, lines",
        mask: "lines",
        linesClass: "line++",
        tag : 'span',
        aria: "none",
        autoSplit: true,
        onSplit: (self) => {
          gsap.set(self.lines, { yPercent: 100, opacity: 0 });
          return gsap.to(self.lines, {
            yPercent: 0,
            opacity: 1,
            ease: "power2.out",
            duration: 0.8,
            stagger: 0.05,
            scrollTrigger : {
              trigger : elem,
              start : 'top 90%',
            }
          });
        }
      });
    });
    
    parallaxElements.forEach((elem) => {
      if(!elem || window.innerWidth < 991) return;
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: elem,
          scrub: 0.1,
        },
      }); 
      tl.from(elem, {
        yPercent: -20,
        ease: "none",
      }).to(elem, {
        yPercent: 20,
        ease: "none",
      }); 
    })

    const categoriesAnimation = () => {
      const section = document.querySelector(".categories-v2");
      if (!section) return;

      const items = gsap.utils.toArray(section.querySelectorAll(".v2-item"));
      const lines = items.map((el) => el.querySelector(".ct-line"));
      const leftImgs = gsap.utils.toArray(section.querySelectorAll(".v2-left img"));
      const rightImgs = gsap.utils.toArray(section.querySelectorAll(".v2-right img"));
      const leftFrame = section.querySelector(".v2-left");
      const rightFrame = section.querySelector(".v2-right");
      const count = items.length;

      const mm = gsap.matchMedia();

      mm.add(
        {
          isDesktop: "(min-width: 992px)",
          isMobile: "(max-width: 991px)",
        },
        (ctx) => {
          const { isDesktop } = ctx.conditions;

          
          gsap.set(items[0], { opacity: 1 });
          gsap.set(lines[0], { scaleX: 1 });
          
          gsap.set(leftImgs.slice(1), { scale: 1.2 });
          gsap.set(rightImgs.slice(1), { scale: 1.2 });

          
          const tl = gsap.timeline({
            defaults: { ease: "none" },
            scrollTrigger: {
              trigger: section,
              start: "top top",
              end: "bottom bottom",
              scrub: 1,
              snap: {
                snapTo: 1 / (count - 1),
                duration: { min: 0.2, max: 0.5 },
                ease: "power1.inOut",
              },
            },
          });

          
          if (isDesktop) {
            tl.fromTo(leftFrame, { yPercent: -25 }, { yPercent: 25, duration: count - 1 }, 0);
            tl.fromTo(rightFrame, { yPercent: 25 }, { yPercent: -25, duration: count - 1 }, 0);
          } else {
            tl.fromTo(leftFrame, { yPercent: 0 }, { yPercent: 0, duration: count - 1 }, 0);
            tl.fromTo(rightFrame, { yPercent: 0 }, { yPercent: 0, duration: count - 1 }, 0);
          }

          
          for (let i = 1; i < count; i++) {
            const pos = i - 1;

            
            tl.to(items[i - 1], { opacity: 0.3, duration: 0.5 }, pos + 0.25);
            tl.to(items[i], { opacity: 1, duration: 0.5 }, pos + 0.4);

            
            tl.to(leftImgs[i], { clipPath: "inset(0% 0 0 0)", duration: 1 }, pos);
            tl.to(leftImgs[i], { scale: 1, duration: 1 }, pos);
            
            tl.to(leftImgs[i - 1], { yPercent: -12, scale: 1.05, duration: 1 }, pos);

            
            tl.to(rightImgs[i], { clipPath: "inset(0 0 0% 0)", duration: 1 }, pos);
            tl.to(rightImgs[i], { scale: 1, duration: 1 }, pos);
            tl.to(rightImgs[i - 1], { yPercent: 12, scale: 1.05, duration: 1 }, pos);
          }

          
          const clickHandlers = items.map((item, i) => {
            const handler = (e) => {
              e.preventDefault();
              const st = tl.scrollTrigger;
              const target = st.start + ((st.end - st.start) * i) / (count - 1);
              gsap.to(window, {
                scrollTo: target,
                duration: 0.8,
                ease: "power2.inOut",
                overwrite: true,
              });
            };
            item.addEventListener("click", handler);
            return handler;
          });

          
          return () => {
            items.forEach((item, i) => item.removeEventListener("click", clickHandlers[i]));
          };
        }
      );
    }
    const hero_anim = () => {
      const hero = document.querySelector('.hero');
      const herowrapper = document.querySelector('.hero-section');
      if(!hero) return;
      const hr_layout = hero.querySelector('.hero_layout--desktop');
      const hr_layoutMobile = hero.querySelector('.hero_layout--mobile');
      const images = window.innerWidth < 768 ? hr_layoutMobile.querySelectorAll('img') : hr_layout.querySelectorAll('img');
      const heroTitle = hero.querySelector('.hero-title');
      const herolines = heroTitle.querySelectorAll('.line-inner');

      const header = document.querySelector('.section-header');
      header.style.transform = 'translateY(-100%)';
      header.style.transition = 'transform 0.8s var(--ease-out-expo)';
      const halfHeight = herowrapper.offsetHeight / 2;
      ScrollTrigger.create({
        trigger: herowrapper,
        start: `top+=${halfHeight} top`, // fires once scrolled halfway through hero
        onEnter: () => header.style.transform = 'translateY(0%)',
        onLeaveBack: () => header.style.transform = 'translateY(-100%)',
      });
      const heroTimeline = gsap.timeline({
        defaults: {
          ease: "power2.out",
        },
        onComplete :() => {
          images.forEach((img) => img.setAttribute("hoverable","true"));
        }
      });
      heroTimeline.to(images,{
        opacity : 1,
        scale : 1,
        rotate : 0,
        duration : 1,
        stagger : {
          each: 0.02,
          from: 'center',
        }
      })
      heroTimeline.to(herolines,{
        y : 0,
        opacity : 1,
        duration : 0.8,
        stagger : 0.3
      }, heroTimeline.duration() * 0.5)
    }

    if (animationState.canStart) {
        categoriesAnimation();
        hero_anim();
        const featuredCards = document.querySelector(".featswiper");
        const featuredProducts = document.querySelector(".products-slider");
        const instagramSlider = document.querySelector('.instagram-swiper');
        const testimonialSlider = document.querySelector('.testimonials-swiper');
        if(testimonialSlider) {
          var swiper =  new Swiper('.testimonials-swiper', {
              slidesPerView: 1.2,
              spaceBetween: 16,
              slidesOffsetBefore: 60,
              slidesOffsetAfter: 60,
              speed : 600,
              loop: false,
              freeMode: true,
              pagination: {
                el: ".test-pagination",
                type: "progressbar",
              },
              mousewheel : {
                forceToAxis : true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1.2,
                  slidesOffsetBefore: 16,
                  slidesOffsetAfter: 16,
                },
                992: {
                  slidesPerView: 2,
                  slidesOffsetBefore: 60,
                  slidesOffsetAfter: 60,
                },
                1280: {
                  slidesPerView: 3.2,
                  spaceBetween: 24,
                },
              },
            });
          }
        if(instagramSlider) {
          var swiper = new Swiper('.instagram-swiper', {
            slidesPerView: 6,
            spaceBetween: 16,
            speed : 600,
            slidesOffsetBefore: 60,
            slidesOffsetAfter: 60,
            freeMode: true,
            mousewheel : {
              forceToAxis : true,
            },
            breakpoints : {
              0 : {
                slidesPerView : 2,
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24,
              },
              991 : {
                slidesPerView : 4,
                slidesOffsetBefore: 60,
                slidesOffsetAfter: 60,
              },
              1200 : {
                slidesPerView : 5,
              },
              1500 : {
                slidesPerView : 6
              }
            }
          });
        }
        if (featuredCards) {
          const swiper = new Swiper(featuredCards, {
            slidesPerView: 1,
            spaceBetween: 16,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
            speed: 500,
            breakpoints: {
              0: {
                slidesPerView: 1,
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24,
              },
              768: {
                slidesPerView: 2,
              },
              991: {
                slidesPerView: 3,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
              },
            },
          });
        }
        if (featuredProducts) {
          const swiper = new Swiper(featuredProducts, {
            slidesPerView: 1,
            spaceBetween: 16,
            slidesOffsetBefore: 60,
            slidesOffsetAfter: 60,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
            speed: 500,
            pagination: {
              el: ".products-pagination",
              type: "progressbar",
            },
            breakpoints: {
              0: {
                slidesPerView: 1.2,
              slidesOffsetBefore: 24,
              slidesOffsetAfter: 24,
              },
              768: {
                slidesPerView: 2.2,
              },
              991: {
                slidesPerView: 3.2,
                slidesOffsetBefore: 60,
                slidesOffsetAfter: 60,
              },
              1500 : {
                slidesPerView : 4.2,
              }
            },
          });
        }
    }
}


const cartDrawer = document.querySelector("cart-drawer");

if (cartDrawer && window.lenis) {
  const observer = new MutationObserver(() => {
    const isOpen = cartDrawer.classList.contains("active");

    if (isOpen) {
      lenis.stop();
    } else {
      lenis.start();
    }
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}